// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"a71b3816","187":"a2176ad8","359":"efda63dc","375":"c7ce2949","430":"66c0e012","472":"207d90f7","656":"82a202f4","936":"3b0f7a9a","981":"12e2ae03"}[chunkId] + ".chunk.css";
};